import { Icon } from '@ui/components';
import { TabDefinition } from '../creator-shell.types';
import { useAppDispatch } from '@lib/redux/store';
import { setShowMessages } from '@lib/redux/features/user';

interface Props {
  filteredTabs: TabDefinition[];
  isLoading: boolean;
  notificationData: any;
  currentTab: string;
  creator?: any;
  isAuthenticated: boolean;
  isFanOfSelectedCreator: boolean;
  handleTabClick: (tabId: string) => void;
}

const MobileTabFooter = (props: Props) => {
  const dispatch = useAppDispatch();

  return (
    <div className="fixed bottom-0 w-full flex justify-between items-center bg-white shadow-xl shadow-black lg:hidden z-50 px-4 py-6">
      {props.filteredTabs.map((tab, idx) => (
        <div
          key={tab.id + idx}
          className={`relative w-[15%] h-5 flex items-end justify-center ${
            props.isLoading ? 'opacity-50' : ''
          }`}
          onClick={() => (props.isLoading ? null : props.handleTabClick(tab.id))}>
          {tab.notificationGetter && tab.notificationGetter(props.notificationData) > 0 && (
            <div className="w-4 h-4 p-1 rounded-full bg-primary text-white absolute -top-2 right-2 flex items-center justify-center text-xs">
              {tab.notificationGetter(props.notificationData)}
            </div>
          )}

          <div className="min-w-fit flex items-center gap-1">
            {tab.icon && (
              <Icon
                type={tab.icon}
                className={`w-5 h-5 mr-1 ${
                  props.isLoading && tab.id !== props.currentTab ? 'animate-pulse' : ''
                }`}
                stroke={props.currentTab === tab.id ? '#FF600D' : '#707B8F'}
              />
            )}
          </div>
        </div>
      ))}

      {props.isAuthenticated && props.isFanOfSelectedCreator && (
        <div
          className={`relative w-[15%] h-5 flex items-center justify-center ${
            props.isLoading ? 'opacity-50' : ''
          }`}
          onClick={() => {
            if (!props.isLoading) {
              dispatch(setShowMessages(true));
            }
          }}>
          {props.creator?.notifications > 0 && (
            <div className="w-4 h-4 p-1 rounded-full bg-primary text-white absolute -top-2 right-2 flex items-center justify-center text-xs">
              {!props.creator?.notifications
                ? ''
                : props.creator?.notifications > 99
                ? '99+'
                : props.creator?.notifications}
            </div>
          )}

          <div className="min-w-fit flex items-center gap-1">
            {
              <Icon
                type={'MessagesIcon'}
                className={`w-4 h-4 mr-1 ${props.isLoading ? 'animate-pulse' : ''}`}
                stroke={props.currentTab === 'Message' ? '#FF600D' : '#707B8F'}
              />
            }
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileTabFooter;
